import { render, staticRenderFns } from "./CompletedOrdersFilter.vue?vue&type=template&id=5602e42e&lang=pug"
import script from "./CompletedOrdersFilter.vue?vue&type=script&lang=js"
export * from "./CompletedOrdersFilter.vue?vue&type=script&lang=js"
import style0 from "./CompletedOrdersFilter.vue?vue&type=style&index=0&id=5602e42e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports